/* @flow */

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  '::selection, ::-moz-selection': {
    backgroundColor: ({ theme }: ThemeFunction) => theme.accentColor,
    color: ({ theme }: ThemeFunction) => theme.textColor,

    textShadow: 'none',
  },
};
